import { hotTops } from '@/mocks/homeData';

export default function HotTopList() {
  return (
    <section id="toplist" className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line"></i>今日热门瓜条
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold text-foreground-950 md:text-[28px]">前排围观 · 实时热度榜</h2>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-refresh-line"></i>每 5 分钟刷新 · 榜一悬念拉满
          </span>
        </div>

        {/* list */}
        <div className="mt-6 grid gap-3 lg:grid-cols-2">
          {hotTops.map((item) => (
            <a
              key={item.rank}
              href="#live"
              className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
            >
              <span
                className={`font-display w-9 shrink-0 text-center text-2xl font-bold leading-none ${
                  item.rank === 1
                    ? 'text-primary-600'
                    : item.rank <= 3
                      ? 'text-accent-600'
                      : 'text-secondary-400'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">{item.title}</h3>
                <div className="mt-1.5 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className={item.hot ? 'ri-fire-fill text-primary-500' : 'ri-eye-line'}></i>
                    {item.heat}
                  </span>
                  <div className="flex gap-1.5">
                    {item.tags.map((t) => (
                      <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900 whitespace-nowrap">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <i className="ri-arrow-right-up-line text-secondary-400 opacity-0 transition-opacity group-hover:opacity-100"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}